/* eslint-disable @typescript-eslint/no-empty-interface */
import { Injectable } from '@angular/core';
import { JSONRPCService, QuizModes } from '@s8l/client-tree-lib';

import { serviceURL } from './service';

enum QuizServer {
  default = 'QUIZ_DEFAULT_SERVER',
  exam = 'QUIZ_EXAM_SERVER',
  review = 'QUIZ_REVIEW_SERVER',
  multiplayer = 'QUIZ_MULTIPLAYER_SERVER',
  casestudy = 'QUIZ_CASESTUDY_SERVER'
}

type ReviewMeta = {
  review: {
    maxAttempts: number;
    minCorrectToPass: number;
  };
};

type ExamMeta = Record<string, unknown>;
type CaseStudyMeta = Record<string, unknown>;

type GameRoundMeta = { review: ReviewMeta['review'] } | { exam: ExamMeta } | { casestudy: CaseStudyMeta };

export type GameRecord = {
  game_id: string;
  game_uuid: string;
  user_uuid: string;
  score: number;
  game_type: string;
  meta: {
    round: GameRoundMeta;
  };
  game_started_at: string;
  game_updated_at: string;
  total_questions: number;
  correct_answers: number;
  total_time: number;
  passed?: boolean;
};

export type PureGameRecord = {
  uuid: string;
  enabled: boolean;
  path: string;
  meta: {
    [key: string]: any;
  };
};

interface GameTypeSettingsParams {
  uuid: String;
  dateFrom?: string;
  dateTo?: string;
}

@Injectable({
  providedIn: 'root'
})
export class QuizTypeServerService extends JSONRPCService {
  public async getGamesByType(type: QuizModes, language?: string): Promise<PureGameRecord[]> {
    return this.message(serviceURL(QuizServer[type], '/rounds'), 'list', { type, language });
  }

  public async getGameTypeSettings(type: QuizModes, params: GameTypeSettingsParams): Promise<GameRecord[]> {
    const data: GameRecord[] = await this.message(serviceURL(QuizServer[type], '/admin/game'), `stats`, params);

    for (const record of data) {
      if ('review' in record.meta.round) {
        record.passed = record.correct_answers >= record.meta.round.review.minCorrectToPass;
      }
    }

    return data;
  }
}
